import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Paper,
  Typography,
  Stack,
  Checkbox,
  IconButton,
  Menu,
  MenuItem,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  DialogContentText,
  Divider,
  FormControl,
  InputLabel,
  Select,
  Tooltip,
  Box,
  Collapse,
  RadioGroup,
  Radio,
  FormControlLabel,
} from "@mui/material";
import _ from "lodash";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { locationsSelector } from "../../../../store/slices/location";
import facts, {
  triggerDeleteFact,
  triggerEditFact,
  triggerInsertFact,
} from "../../../../store/slices/facts";
import NewFacts from "./factModals/newFact";
import EditFact from "./factModals/editFact";
import InfoIcon from "@mui/icons-material/Info";
import { convertArrayToDictionary } from "../../../../common/utils";
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import KeyboardArrowUpOutlinedIcon from '@mui/icons-material/KeyboardArrowUpOutlined';
import { isValidJSON } from "./reviewUtils";

const Facts = ({
  data,
  classes,
  selectededReview,
  selectedLocation,
  selectedCompany,
  reviewId,
  selectedFacts,
  setSelectedFacts,
  selectedThen,
  setSelectedThen
}) => {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    factId: "",
    companyId: "",
    locationId: "all",
    fact: "",
  });
  const [editMode, setEditMode] = useState(false);
  const [selectedFactId, setSelectedFactId] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openWarning, setWarning] = useState(false);
  const { locations, regions, brands } = useSelector(locationsSelector);

  const locationDic = React.useMemo(() => convertArrayToDictionary(locations, 'locationId'), [locations])
  const brandDic = React.useMemo(() => convertArrayToDictionary(brands, 'brandId'), [brands])
  const regionDic = React.useMemo(() => convertArrayToDictionary(regions, 'regionId'), [regions])
  const [openThen, setOpenThen] = useState(false);
  // const [selectedThen, setSelectedThen] = useState({});
  
  const dispatch = useDispatch();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleSelectedFacts = (fact) => {
    const existingFact = _.find(selectedFacts, (it) => it.factId === fact.factId);
    if (existingFact) {
      setSelectedFacts((prev) =>
        _.filter(prev, (a) => a.factId !== fact.factId)
      );
    } else {
      handleThen(fact, selectedThen[fact.factId]?.index || 0);
    }
    const newThen = { ...selectedThen, [fact.factId]: { ...selectedThen?.[fact.factId], selected: !selectedThen?.[fact.factId]?.selected } };
    dispatch(setSelectedThen(newThen));
  };

   const handleThen = (fact, idx) => {
    const factId = fact.factId;
    const thenText = fact?.factJson?.Then?.[idx]?.text || '';
    const ifText = fact?.factJson?.If?.text || '';
    const fullFactText = `What was relevant: ${ifText} \n Include in the Response: ${thenText}`;

    const newThen = {
      ...selectedThen,
      [factId]: {
        factId: factId,
        if: `What was relevant: ${ifText}`,
        then: `Include in the Response: ${thenText}`,
        index: idx,
        selected: true
      }
    };
    dispatch(setSelectedThen(newThen));

    const existingFactIndex = _.findIndex(selectedFacts, (it) => it.factId === factId);

    if (existingFactIndex > -1) {
      const updatedSelectedFacts = [...selectedFacts];
      if (updatedSelectedFacts[existingFactIndex].selectedThenIndex === idx) {
       
        setSelectedFacts(_.filter(selectedFacts, (it) => it.factId !== factId));
      } else {
        
        updatedSelectedFacts[existingFactIndex] = {
          ...updatedSelectedFacts[existingFactIndex],
          if: `What was relevant: ${ifText}`,
          then: `Include in the Response: ${thenText}`,
          selectedThenIndex: idx,
        };
        setSelectedFacts(updatedSelectedFacts);
      }
    } else {
      
      setSelectedFacts(prev => [...prev, { ...fact, if: `What was relevant: ${ifText}`, then: `Include in the Response: ${thenText}`, selectedThenIndex: idx }]);
    }
  };


  const handleClickOpen = (data) => {
    setFormData(data);
    setEditMode(false);
    setOpen(true);
  };
  const locationsList = useMemo(() => _.cloneDeep(locations), [locations]);
  const handleCloseModal = () => {
    setOpen(false);
    setFormData({
      factId: "",
      companyId: "",
      locationId: "all",
      fact: "",
    });
    setEditMode(false);
  };

  const handleAddOrEdit = () => {
    let dispatchData = _.cloneDeep(formData);
    dispatchData["locationId"] =
      dispatchData?.locationId !== "all" ? formData?.locationId : null;
    if (editMode) {
      dispatch(triggerEditFact(dispatchData, reviewId));
    } else {
      dispatch(triggerInsertFact(dispatchData, reviewId));
    }

    handleCloseModal();
  };

  const handleEditClick = (data) => {
    setEditMode(true);
    setOpen(true);
    handleClose();
  };

  const newData = useMemo(() => {
    const reviewLocation = locationDic[selectededReview?.[0]?.locationId];
    
    const multipleBrands = reviewLocation?.brandId ? _.unionBy(_.filter(locations, { brandId: reviewLocation?.brandId }), 'locationId') : [];
    const multipleRegions = reviewLocation?.regionId ? _.unionBy(_.filter(locations, { regionId: reviewLocation?.regionId }), 'locationId') : [];
    return reviewId?.length > 0 ? _.filter(_.map(_.cloneDeep(data), (item) => {
      
      const isLocation = _.toLower(item.entityType) === 'location';
      const isRegion = _.toLower(item.entityType) === 'region';
      const isBrand = _.toLower(item.entityType) === 'brand';
      if (reviewLocation && (
        (item?.entityIds?.length > 0 && isLocation && _.includes(item?.entityIds, reviewLocation?.locationId))
        || (item?.entityIds?.length > 0 && isRegion && _.includes(item?.entityIds, reviewLocation?.regionId))
        || (item?.entityIds?.length > 0 && isBrand && _.includes(item?.entityIds, reviewLocation?.brandId))
      )) {
        const isMany = (isLocation && item?.entityIds?.length > 1) ? true :
          (isRegion && multipleRegions?.length > 1) ? true :
            (isBrand && multipleBrands?.length > 1) ? true : false;
        return {
          ...item,
          factJson: isValidJSON(item?.factJson) ? JSON.parse(item.factJson) : null,
          locationName: isMany ? 'Multiple Locations' : reviewLocation?.name,
        };
      }
      const factJson = isValidJSON(item?.factJson) ? JSON.parse(item.factJson) : null;
      return !item?.entityIds?.length ? {...item, factJson} : null;
    }), it => { return it }) : [];
  }, [data, locationDic, locations, selectededReview, reviewId]);


  const filteredAndSortedData = useMemo(() => {
    return _.orderBy(newData, "similarity", "desc")
    if (selectedLocation === "all") {
      return _.orderBy(newData, "similarity", "desc");
    } else {
      return _.orderBy(
        newData.filter((fact) => fact.locationId === selectedLocation),
        "similarity",
        "desc"
      );
    }
  }, [newData, selectedLocation]);
  const handleWarningDelete = (factId) => {
    setSelectedFactId(formData?.factId);
    setWarning(true);
    handleClose();
  };
  const handleDelete = () => {
    dispatch(triggerDeleteFact(selectedFactId, reviewId));
    setWarning(false);
    handleClose();
  };
  useEffect(()=>{
    const randomThenHeader = {};
     if(_.isEmpty(selectedThen)){  
      
      filteredAndSortedData.forEach(fact => {
      const factId = fact.factId;
      const index = Math.floor(Math.random() * (fact?.factJson?.Then?.length || 1));
      const thenText = fact?.factJson?.Then?.[index]?.text || '';
      const ifText = fact?.factJson?.If?.text || '';
      const fullFactText = `What was relevant: ${ifText} Include in the Response: ${thenText}`;
      randomThenHeader[factId] = {
        factId: factId,
        if: `What was relevant: ${ifText}`,
        then: `Include in the Response: ${thenText}`,
        index: index,
        selected: false
      }
    })
    dispatch(setSelectedThen(randomThenHeader));}
  },[filteredAndSortedData])
  
  return (
    <>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Stack sx={{width:'100%',pl:2}} direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
        <Typography sx={{mt:2}}>Relevant facts are already selected</Typography>
        {/* <Button
          sx={{ textTransform: "none", mt: 2 }}
          disabled={selectedCompany?.trim() === ""}
          variant="outlined"
          color="primary"
          onClick={() =>
            handleClickOpen({
              companyId: selectedCompany,
              locationId: selectedLocation,
              fact: "",
            })
          }
        >
          Add Fact
        </Button> */}
        </Stack>
      </div>
      <div className={classes.reviewContainer2}>
        <div className={classes.innerContainer}>
          {filteredAndSortedData?.map((fact, index) => 
         {
          
          
         return (
            <Paper key={index} className={classes.reviewBox}>
              <div>
                <div className={classes.reviewHeader}>
                  <Stack direction="row" spacing={1} alignItems={"center"}>
                    <Checkbox
                      size="small"
                      checked={selectedThen?.[fact.factId]?.selected || false}
                      onChange={() => handleSelectedFacts(fact)}
                    />
                    <Typography variant="subtitle2">
                      {fact?.locationName
                        ? fact?.locationName
                        : "All Locations"}
                    </Typography>
                  </Stack>
                  {/* <Box>
                    {fact?.similarity && (
                      <Tooltip title={fact?.similarity}>
                        <span>
                          <IconButton size="small">
                            <InfoIcon fontSize="small" />
                          </IconButton>
                        </span>
                      </Tooltip>
                    )}
                   
                    <IconButton
                      size="small"
                      aria-label="More Options"
                      onClick={(e) => {
                        handleClick(e);
                        setFormData({
                          factId: fact?.factId,
                          companyId: fact?.companyId,
                          locationId: fact?.locationId ? fact.locationId : "all",
                          fact: fact?.fact,
                          ...fact
                        });
                      }}
                    >
                 

                  <MoreVertIcon />
                </IconButton>
                </Box> */}
                {/* </Tooltip> */}
              </div>
             <Box>
              <Stack direction={'row'} alignItems={'center'} mb={2}>
               <IconButton onClick={() => setOpenThen((prev) => ({ ...prev, [fact.factId]: !prev[fact.factId] }))}> 
                 {openThen?.[fact.factId] ? <KeyboardArrowUpOutlinedIcon  fontSize="small" sx={{ cursor: 'pointer' }} /> : <KeyboardArrowDownOutlinedIcon  fontSize="small" sx={{ cursor: 'pointer' }} />}
               </IconButton>

              <Typography
                variant="body1" 
                position={'relative'}
                sx={{cursor:'pointer', pl:1,}}
                
                >
                  {fact?.factJson?.If ? fact.factJson.If.text : ''}  {fact?.factJson?.Then?.[selectedThen?.[fact.factId]?.index]?.text}
                </Typography>
                </Stack>
              {/* <Typography onClick={() => setOpenThen((prev) => ({ ...prev, [fact.factId]: !prev[fact.factId] }))} sx={{display:'flex', alignItems:'center', cursor:'pointer'}}>
                 {fact?.factJson?.Then?.[selectedThen?.[fact.factId]?.index]?.text}
                {openThen?.[fact.factId] ? <KeyboardArrowUpOutlinedIcon  fontSize="small" sx={{ cursor: 'pointer' }} /> : <KeyboardArrowDownOutlinedIcon  fontSize="small" sx={{ cursor: 'pointer' }} />}
              </Typography> */}
              <Collapse in={openThen?.[fact.factId]} timeout="auto" unmountOnExit>
              <RadioGroup value={selectedThen?.[fact.factId]?.index || 0} onChange={(e) => handleThen(fact, parseInt(e.target.value))} sx={{paddingLeft:'44px'}}>
               {_.map(fact?.factJson?.Then, (item, index) => (
                 <FormControlLabel
                    key={index}
                    value={index}
                    control={<Radio size="small" />}
                    label={<Typography variant="body1" sx={{pl:1}}>{item.text}</Typography>}
                    sx={{'&.MuiFormControlLabel-root':{mr:0, mb:1}}}
                    />
               ))}
              </RadioGroup>
              </Collapse>
              </Box>
            </div>
            </Paper>
          )})}
      </div>
    </div >
    {/* {editMode&&<Dialog
        maxWidth="md"
        fullWidth
        open={open}
        aria-labelledby="form-dialog-title"
        onClose={handleCloseModal}
      >
        <DialogTitle id="form-dialog-title">
          {editMode ? "Edit Fact" : "Add Fact"}
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Stack spacing={2}>
            <FormControl size="small" fullWidth>
              <InputLabel>Location</InputLabel>
              <Select
                label="Location"
                size="small"
                fullWidth
                value={formData?.locationId ? formData.locationId : ""}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    locationId: e.target.value,
                  }))
                }
              >
                <MenuItem value={"all"}>All</MenuItem>
                {_.map(locationsList, (location) => (
                  <MenuItem
                    key={location?.locationId}
                    value={location?.locationId}
                  >
                    {location?.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              autoFocus
              margin="dense"
              id="fact"
              label="Fact"
              type="text"
              fullWidth
              multiline
              rows={4}
              value={formData.fact ?? ""}
              onChange={(e) =>
                setFormData((prev) => ({ ...prev, fact: e.target.value }))
              }
            />
          </Stack>
        </DialogContent>
        <Divider />
        <DialogActions
          sx={{ display: "flex", justifyContent: "start", my: 1, px: 3 }}
        >
          <Button
            onClick={handleAddOrEdit}
            variant="contained"
            size="small"
            color="primary"
            disabled={!Boolean(formData?.fact)}
          >
            {editMode ? "Save" : "Add"}
          </Button>
          <Button
            onClick={handleCloseModal}
            size="small"
            variant="outlined"
            color="error"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>} */}
  {
    openWarning && (
      <Dialog open={openWarning}>
        <DialogTitle>Delete Confirmation</DialogTitle>
        <Divider />
        <DialogContent>
          Are you sure you want to delete this fact?
        </DialogContent>
        <Divider />
        <DialogActions
          sx={{ display: "flex", justifyContent: "start", my: 1, px: 3 }}
        >
          <Button
            onClick={handleDelete}
            variant="contained"
            size="small"
            color="error"
          >
            Delete
          </Button>
          <Button
            onClick={() => setWarning(false)}
            size="small"
            variant="outlined"
            color="primary"
            sx={{ ml: 2 }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
  {/* <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
    <MenuItem onClick={() => handleEditClick()}>Edit</MenuItem>
    <MenuItem onClick={() => handleWarningDelete()}>Delete</MenuItem>
  </Menu> */}
  { open && !editMode && <NewFacts open={open} setOpen={setOpen} companyId={formData?.companyId} reviewId={reviewId} /> }
  { open && editMode && <EditFact open={open} setOpen={setOpen} fact={formData} companyId={formData?.companyId} reviewId={reviewId} openWarning={openWarning} setOpenWarning={setWarning} /> }
    </>
  );
};

export default Facts;
